import React from "react";
import aboutUs from "../../PicesForPages/ConventionalLoans.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function ConventionalLoans() {
  return (
    <>
      <div className="purchaseParent">
        <div className="purchasetopParent">
          <img
            fetchPriority="high"
            loading="eager"
            src={aboutUs}
            alt="aboutUsImage"
            className="background-video"
          />
          <div className="purchasetopBox">Conventional Loans</div>
        </div>
        {/* <div className="joinTheTeamFormParent"> */}
        <div className="purchaseBottomParent">
          <div className="purchaseBottomBox joinTheTeamBottomBox">
            <div className="purchaseBottomLeftBox">
              {/* <span className="purchaseBottomLeftHeader">
                What can FHA offer you?
              </span>
              <span className="purchaseBottomLeftSubHeader">
                First-time homebuyer?
              </span> */}
              {/* <div className="purchaseBottomLeftHeader">Conventional Loans</div> */}

              <span className="purchaseBottomLeftContent">
                Conventional loans remain a popular financing tool for
                homebuyers who can demonstrate sound credit and provide a
                reasonable down payment without relying on government-backed
                guarantees. Unlike FHA or VA loans, conventional mortgages are
                issued and underwritten by private lenders, which necessitates
                adherence to stricter credit guidelines but often rewards
                borrowers with competitive interest rates and flexible terms.
              </span>

              <span className="purchaseBottomLeftSubHeader">
                Conforming Conventional Loans
              </span>
              <span className="purchaseBottomLeftContent">
                Conforming loans are structured to meet the eligibility
                standards established by Fannie Mae and Freddie Mac. These loans
                must conform to maximum loan limits and other standardized
                underwriting criteria. Borrowers benefit from typically lower
                interest rates and standardized terms. However, if the down
                payment falls below a certain threshold, private mortgage
                insurance (PMI) is required until sufficient equity is reached.
              </span>

              <span className="purchaseBottomLeftSubHeader">
                Non-Conforming Conventional Loans
              </span>
              <span className="purchaseBottomLeftContent">
                Non-conforming loans do not meet the guidelines for Fannie Mae
                or Freddie Mac. A common example is a jumbo loan, designed for
                borrowers seeking financing that exceeds the upper limits of the
                conforming category. These loans are subject to lender-specific
                criteria, which can include higher down payment requirements and
                more stringent credit standards. Some lenders also offer
                specialized non-conforming programs tailored to borrowers with
                unique financial circumstances.
              </span>

              <span className="purchaseBottomLeftSubHeader">
                Loan Term Options
              </span>
              <span className="purchaseBottomLeftContent">
                Borrowers can choose between fixed-rate and adjustable-rate
                structures within conventional loan programs. Fixed-rate loans
                maintain a constant interest rate over the life of the mortgage,
                providing predictability in payment structures. In contrast,
                adjustable-rate loans generally offer a lower initial rate that
                may change periodically, aligning with market conditions—ideal
                for buyers planning to refinance or sell in a shorter period.
              </span>
              <i className="purchaseBottomLeftContent">
                Disclaimer: This blog is for informational purposes only and
                does not constitute legal, financial, or tax advice. Please
                consult with a professional for personalized guidance.
              </i>
            </div>
            <FreeConsultation />
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default ConventionalLoans;
